import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
import { CTAButton } from './CTAButton';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — Sistema Base de Clases',
  subtitle: 'Nivel Inicial (4–6 años)',
  accent: 'border-l-blue-500',
  items: ['Estructura clara del aula', 'Inicio – Desarrollo – Cierre', 'Organización sin improvisación', 'Rutinas base', 'Control del grupo desde el primer minuto', 'Clase ordenada desde el inicio']
}, {
  icon: '🟢',
  title: 'Tomo 2 — Actividades de Comunicación',
  subtitle: 'Lenguaje y Expresión',
  accent: 'border-l-green-500',
  items: ['Escuchar – Hablar – Expresar', 'Participación activa', 'Juegos de lenguaje', 'Estimulación verbal', 'Desarrollo de confianza', 'Actividades listas para interacción diaria']
}, {
  icon: '🟡',
  title: 'Tomo 3 — Actividades de Matemática',
  subtitle: 'Pensamiento Lógico Inicial',
  accent: 'border-l-yellow-400',
  items: ['Contar – Comparar – Ordenar', 'Números básicos', 'Secuencias simples', 'Juegos matemáticos', 'Aprendizaje visual y práctico', 'Comprensión sin frustración']
}, {
  icon: '🟣',
  title: 'Tomo 4 — Actividades Sensoriales y Motrices',
  subtitle: 'Regulación y Movimiento',
  accent: 'border-l-purple-500',
  items: ['Explorar – Mover – Regular', 'Actividades sensoriales', 'Coordinación motriz', 'Canalización de energía', 'Control de impulsos', 'Niños más enfocados y tranquilos']
}, {
  icon: '🔴',
  title: 'Tomo 5 — Clases Completas Día a Día',
  subtitle: 'Aplicación Directa',
  accent: 'border-l-red-500',
  items: ['Clases listas para usar', 'Paso a paso diario', 'Sin planificación adicional', 'Actividades organizadas', 'Fluidez en el aula', 'Enseñar sin pensar qué hacer']
}, {
  icon: '🟤',
  title: 'Tomo 6 — Organización Mensual',
  subtitle: 'Planificación Inteligente',
  accent: 'border-l-amber-800',
  items: ['Plan mensual estructurado', 'Organización por semanas', 'Claridad total del contenido', 'Anticipación de clases', 'Ahorro de tiempo', 'Control total del proceso educativo']
}];
const features = ['Actividades listas para aplicar', 'Estructura paso a paso', 'Recursos visuales', 'Ejercicios imprimibles', 'Aplicación inmediata en aula'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-306">
      <div className="max-w-xl mx-auto" data-id="element-307">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-308">
          📚 LO QUE RECIBES
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-309">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-310">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-gray-900 border border-gray-800 border-l-4 ${tomo.accent} rounded-lg overflow-hidden`} data-id="element-311">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-312">
                  <span className="text-2xl flex-shrink-0" data-id="element-313">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-314">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-315">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-316">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-317" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-318" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-319">
                    <div className="space-y-2" data-id="element-320">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-321">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-322" />
                          <span className="text-xs text-gray-400" data-id="element-323">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-10" data-id="element-324">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-4" data-id="element-325">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-326">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-327">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-328" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-329">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-330">
          <CTAButton text="👉 QUIERO TODO LISTO HOY" className="w-full md:w-auto mx-auto" data-id="element-331" />
        </div>
      </div>
    </section>;
}